/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllRealms = (state: { realm: any }) => state.realm.realms;
export const selectAllFilteredRealms = (state: { realm: any }) => state.realm.filteredRealms;
export const selectSelectedRealm = (state: { realm: any }) => state.realm.selectedRealm;
export const selectNoRealm = (state: { realm: any }) => state.realm.noRealm;
export const selectRealmDetails = (state: { realm: any }) => state.realm.selectedRealmDetails;
export const selectRealmPagination = (state: { realm: any }) => state.realm.pagination;
export const selectAllIdps = (state: { realm: any }) => state.realm.idps;
export const selectByIdpStatus = (state: { realm: any }) => state.realm.byIdpStatus;